function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { Headers } from '@sail/data';
const wrappedCache = new WeakMap();
// Historically we used to change the case of all headers passed through data-v2 to uppercase.
// e.g. Stripe-Context instead of stripe-context.
// This was done by the fetch wrapper from request signing.
// To not break this behaviour, we need to maintain this behaviour as otherwise
// it could lead to breaking changes (e.g. http://go/ir/feast-anticipate).
export default function wrapFetchWithNormalizeHeaders(fetch) {
    const wrappedFetch = wrappedCache.get(fetch);
    if (wrappedFetch) {
        return wrappedFetch;
    }
    const newWrappedFetch = function() {
        var _withNormalizeHeaders = _async_to_generator(function*(url, options = {}) {
            const { headers } = options, rest = _object_without_properties(options, [
                "headers"
            ]);
            const finalHeaders = new Headers(headers);
            const normalizedHeaders = finalHeaders.getFetchHeaders();
            return fetch(url, _object_spread({
                headers: normalizedHeaders
            }, rest));
        });
        function withNormalizeHeaders(url) {
            return _withNormalizeHeaders.apply(this, arguments);
        }
        return withNormalizeHeaders;
    }();
    wrappedCache.set(fetch, newWrappedFetch);
    return newWrappedFetch;
}

//# sourceMappingURL=wrapFetchWithNormalizeHeaders.js.map